import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'iv-radio-button-option',
  templateUrl: './radio-button-option.component.html',
  styleUrls: ['./radio-button-option.component.scss']
})
export class RadioButtonOptionComponent {
  managed_by_cbre;
  @Input() property;
  @Output() saveProperty;
  @Input() index = 0;
  constructor() {
    this.saveProperty = new EventEmitter();
  }
  radioSelected(value) {
    this.property.managed_by_cbre = (value === true || value === 'true');
    this.saveProperty.emit({ managed_by_cbre: this.property.managed_by_cbre });
  }
}
